var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArbitrum = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.783 11.317 1.814-3.078 4.889 7.615.002 1.462-.016-10.057a.757.757 0 0 0-.35-.603l-8.803-5.063a.776.776 0 0 0-.751.048l-.03.02-8.545 4.951-.033.015a.755.755 0 0 0-.441.643l.013 8.195 4.554-7.058C6.66 7.47 7.91 7.169 9.068 7.186l1.362.036-8.02 12.86.945.545 8.116-13.392 3.587-.013-8.095 13.73 3.374 1.94.403.232c.17.07.371.073.543.01l8.926-5.172-1.706.989-4.72-7.634Zm.692 9.968-3.407-5.348 2.08-3.529 4.474 7.053-3.147 1.824Z",
    fill: "#2D374B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.068 15.938 3.407 5.347 3.148-1.824-4.475-7.053-2.08 3.53ZM20.489 17.316l-.003-1.461-4.889-7.616-1.814 3.078 4.72 7.634 1.707-.99a.756.756 0 0 0 .279-.55v-.095Z",
    fill: "#28A0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 18.694 2.41 1.389 8.02-12.861-1.361-.036c-1.16-.017-2.41.285-2.983 1.22l-4.554 7.06L0 17.818v.875ZM15.058 7.222l-3.587.013-8.116 13.392 2.837 1.633.772-1.308 8.094-13.73Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.203a2.285 2.285 0 0 0-1.073-1.837L12.01.238a2.32 2.32 0 0 0-2.046 0C9.889.275 1.29 5.262 1.29 5.262A2.267 2.267 0 0 0 0 7.199v10.62l1.532-2.354L1.52 7.27a.754.754 0 0 1 .315-.57c.04-.028 8.785-5.09 8.813-5.104a.776.776 0 0 1 .672-.003l8.803 5.063a.757.757 0 0 1 .35.603v10.152a.74.74 0 0 1-.263.55l-1.706.99-.88.51-3.148 1.824-3.192 1.85a.774.774 0 0 1-.543-.011l-3.777-2.172-.771 1.308 3.394 1.954.294.167c.127.071.213.119.244.133.241.117.588.186.901.186.287 0 .566-.053.83-.157l9.272-5.369A2.266 2.266 0 0 0 22 17.467V7.203Z",
    fill: "#96BEDC"
  })));
};
export default SvgArbitrum;